import {
    initialSignalTileDataState,
    initialSignalTileStreamState,
    SignalTileDataItemState,
    SignalTileDataState,
    SignalTileStreamsState,
    SignalTileStreamState,
} from './SignalTileStreamState';
import timeSeriesReducer from 'utils/timeseries/timeSeriesUtils';
import {
    SignalTileDataElement,
    SignalTileTimeSeriesElement,
} from 'widgets/signalTiles/signalTile/api/SignalTileElement';
import { StreamMessageElement } from 'communication/types/StreamElement';
import streamMessagesReducer from 'utils/messages/StreamMessage';
import State from 'store/State';
import { StreamElementType } from 'communication/types/StreamElementType';
import { buildStreamedDataStreamSlice } from 'streamsState/store/streamedData/streamSlice';
import { ChannelDestination } from 'communication/Channel';
import { signalTileStreamRequestBuilders } from './SignalTileStreamRequest';
import { SignalTileConfigState } from 'widgets/signalTiles/signalTile/state/config/SignalTileConfigState';
import { WidgetType } from 'widgets/WidgetType';

const buildProcessSignalTileStreamElement =
    <TData>(mapValue: (item: TData) => SignalTileDataItemState) =>
    (
        element: SignalTileDataElement<TData>,
        nextState: SignalTileStreamState
    ) => {
        const nextDataState: SignalTileDataState = nextState.data ?? {
            ...initialSignalTileDataState,
        };
        const streamElement = element as SignalTileTimeSeriesElement<TData>;
        // // TODO: remove this when Henry or Thomasz fix the back end
        // if (streamElement._i !== 0) {
        const mapped: { _i: number; _c: StreamElementType; value: number } = {
            _i: streamElement._i,
            _c: streamElement._c,
            ...mapValue(streamElement),
        };
        timeSeriesReducer(mapped, nextDataState);
        //}
        streamMessagesReducer(element as StreamMessageElement, nextState);
    };

export function buildSignalTileStreamSlice<TDataElement>(
    widgetType: WidgetType,
    channel: ChannelDestination,
    selectStreamedData: (state: State) => SignalTileStreamsState,
    mapValue: (item: TDataElement) => SignalTileDataItemState,
    initialConfig: SignalTileConfigState
) {
    const { createSignalTileRequestUid, toSignalRequestUid } =
        signalTileStreamRequestBuilders(widgetType, initialConfig);

    const processDataStreamElement =
        buildProcessSignalTileStreamElement(mapValue);

    return buildStreamedDataStreamSlice<
        SignalTileDataState,
        SignalTileConfigState,
        SignalTileDataElement<TDataElement>,
        SignalTileStreamState
    >(
        channel,
        initialSignalTileStreamState,
        selectStreamedData,
        createSignalTileRequestUid,
        toSignalRequestUid,
        processDataStreamElement
    );
}
